export default __webpack_public_path__ + "static/media/user-teal.2d095fe1.svg";